import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import evaluationsReducer from './evaluationsSlice';
import productReducer from './productSlice';
import applicationReducer from './applicationSlice';
import knowledgeBaseReducer from './knowledgeBaseSlice';
import organisationReducer from './organisationSlice';
import sprintReducer from './sprintSlice';
import bugReducer from './bugSlice';
import folderReducer from './folderSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    evaluations: evaluationsReducer,
    products: productReducer,
    applications: applicationReducer,
    knowledgeBase: knowledgeBaseReducer,
    organisations: organisationReducer,
    sprints: sprintReducer,
    bugs: bugReducer,
    folders: folderReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
